import { H1, Chip, TertiaryButton } from "@coherehealth/common";
import { Grid, Box, Divider } from "@mui/material";
import SupervisorSearch from "./SupervisorSearch";
import { RouteConfigByCaseType } from "@coherehealth/qm-api";

interface PageHeaderProps {
  headerLabel: string;
  chipLabel?: string;
  tertiaryButtonTestid?: string;
  tertiaryButtonLabel?: string;
  tertiaryButtonAction?: () => void;
  hideBottomLine?: boolean;
  supervisorSearch?: boolean;
  routeConfigByCaseType?: RouteConfigByCaseType;
  activeQueueId?: string;
}

const PageHeader = ({
  headerLabel,
  chipLabel,
  hideBottomLine,
  tertiaryButtonTestid,
  tertiaryButtonAction,
  tertiaryButtonLabel,
  supervisorSearch,
  routeConfigByCaseType,
  activeQueueId,
}: PageHeaderProps) => {
  return (
    <Grid container style={{ display: "flex", justifyContent: "space-between" }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <H1 style={{ marginRight: "0.5em" }}>{headerLabel}</H1>
        {chipLabel && <Chip label={chipLabel} style={{ borderRadius: "4px", height: "24px", minWidth: "79px" }} />}
        {tertiaryButtonLabel && (
          <Box sx={{ pt: "4px" }}>
            <TertiaryButton
              style={{ borderRadius: "4px", height: "100%", padding: "4px", alignItems: "center" }}
              onClick={(event) => {
                tertiaryButtonAction && tertiaryButtonAction();
                event.currentTarget.blur();
              }}
              data-testid={tertiaryButtonTestid}
            >
              {tertiaryButtonLabel}
            </TertiaryButton>
          </Box>
        )}
      </Box>
      {supervisorSearch && (
        <Box>
          <SupervisorSearch routeConfigByCaseType={routeConfigByCaseType} activeQueueId={activeQueueId} />
        </Box>
      )}
      {!hideBottomLine && <Divider variant="fullWidth" sx={{ width: "100%", my: "1em" }} />}
    </Grid>
  );
};

export default PageHeader;
